
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hzOq6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9ib3C = parcelRequire("9ib3C");


var $iDrrr = parcelRequire("iDrrr");


var $bZTfQ = parcelRequire("bZTfQ");

const $fe745d51ff14e905$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
const $fe745d51ff14e905$export$9923361bd43fa030 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(12);
    const { label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, testId: testId, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup } = t0;
    const pickedAppSwitcherIcon = (0, $iDrrr.fg)("platform_dst_ads_appswitcher_improvements") ? icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($9ib3C))) : (0, (/*@__PURE__*/$parcel$interopDefault($9ib3C)));
    let t1;
    if ($[0] !== ariaControls || $[1] !== ariaExpanded || $[2] !== ariaHasPopup || $[3] !== interactionName || $[4] !== isSelected || $[5] !== label || $[6] !== onClick || $[7] !== onMouseEnter || $[8] !== pickedAppSwitcherIcon || $[9] !== ref || $[10] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZTfQ.IconButton), {
            ref: ref,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            icon: pickedAppSwitcherIcon,
            label: label,
            appearance: "subtle",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            interactionName: interactionName,
            isTooltipDisabled: false,
            tooltip: $fe745d51ff14e905$var$toggleButtonTooltipOptions,
            isSelected: isSelected,
            testId: testId
        });
        $[0] = ariaControls;
        $[1] = ariaExpanded;
        $[2] = ariaHasPopup;
        $[3] = interactionName;
        $[4] = isSelected;
        $[5] = label;
        $[6] = onClick;
        $[7] = onMouseEnter;
        $[8] = pickedAppSwitcherIcon;
        $[9] = ref;
        $[10] = testId;
        $[11] = t1;
    } else t1 = $[11];
    return t1;
} : ({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, testId: testId, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const pickedAppSwitcherIcon = (0, $iDrrr.fg)('platform_dst_ads_appswitcher_improvements') ? icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($9ib3C))) : (0, (/*@__PURE__*/$parcel$interopDefault($9ib3C)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZTfQ.IconButton), {
        ref: ref,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        icon: pickedAppSwitcherIcon,
        label: label,
        appearance: "subtle",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        interactionName: interactionName,
        isTooltipDisabled: false,
        tooltip: $fe745d51ff14e905$var$toggleButtonTooltipOptions,
        isSelected: isSelected,
        testId: testId
    });
});
module.exports["AppSwitcher"] = $fe745d51ff14e905$export$9923361bd43fa030;

});

parcelRegister("ehvof", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $7vK9E = parcelRequire("7vK9E");


var $1fHIr = parcelRequire("1fHIr");


var $6cyWf = parcelRequire("6cyWf");


var $oHJVG = parcelRequire("oHJVG");

const $0587785bc5340d25$var$anchorStyles = {
    root: "_0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VUofl",
    customLogoBorderRadius: "_0bjKvD8fU6",
    newMargin: "_0GTcwR1Y8M",
    newInteractionStates: "_1eOmH6o126 _3gzVzLJovG",
    newInteractionStatesCustomTheming: "_1eOmH6JxD8 _3gzVzL8abp"
};
const $0587785bc5340d25$var$sharedIconOrLogoContainerStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _2Y7lL41Y8M _0LETLXoWWg _1PTmduOLYo _3G0Ib8gIor",
    withFullHeightSidebar: "_1EqgXlN91d _4ouGXIoWWg"
};
const $0587785bc5340d25$var$iconContainerStyles = {
    root: "_3iDTPbQ4SZ _1EqgXloWWg _24h04iPvdi _2rc81eYbGa"
};
const $0587785bc5340d25$var$logoContainerStyles = {
    root: "_3iDTPbYbGa _1EqgXlsz7G _24h04iPvdi _2rc81eQ4SZ"
}; /**
    * __Custom logo__
    *
    * Custom logo for the top navigation.
    *
    * To provide a responsive experience, it requires both a logo and an icon component.
    * The logo component will be used for large viewports, and the icon component will be used for small viewports.
    */ 
const $0587785bc5340d25$export$4156d88e9ccc616b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { href: href, logo: logo, icon: icon, onClick: onClick, label: label } = t0;
    const ref = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            return;
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const t3 = hasCustomTheme ? $0587785bc5340d25$var$anchorStyles.newInteractionStatesCustomTheming : $0587785bc5340d25$var$anchorStyles.newInteractionStates;
    let t4;
    if ($[2] !== t3) {
        t4 = (0, $k12R1.cx)($0587785bc5340d25$var$anchorStyles.root, $0587785bc5340d25$var$anchorStyles.customLogoBorderRadius, $0587785bc5340d25$var$anchorStyles.newMargin, t3);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const t5 = isFhsEnabled && $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.withFullHeightSidebar;
    let t6;
    if ($[4] !== t5) {
        t6 = (0, $hekY6.default)([
            $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.root,
            $0587785bc5340d25$var$iconContainerStyles.root,
            t5
        ]);
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== icon) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $oHJVG.LogoRenderer), {
            logoOrIcon: icon
        });
        $[6] = icon;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== t6 || $[9] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t6
        }, t7);
        $[8] = t6;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    const t9 = isFhsEnabled && $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.withFullHeightSidebar;
    let t10;
    if ($[11] !== t9) {
        t10 = (0, $hekY6.default)([
            $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.root,
            $0587785bc5340d25$var$logoContainerStyles.root,
            t9
        ]);
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    let t11;
    if ($[13] !== logo) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $oHJVG.LogoRenderer), {
            logoOrIcon: logo
        });
        $[13] = logo;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== t10 || $[16] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t10
        }, t11);
        $[15] = t10;
        $[16] = t11;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== href || $[19] !== label || $[20] !== onClick || $[21] !== t12 || $[22] !== t4 || $[23] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            ref: ref,
            "aria-label": label,
            href: href,
            xcss: t4,
            onClick: onClick
        }, t8, t12);
        $[18] = href;
        $[19] = label;
        $[20] = onClick;
        $[21] = t12;
        $[22] = t4;
        $[23] = t8;
        $[24] = t13;
    } else t13 = $[24];
    return t13;
} : ({ href: href, logo: logo, icon: icon, onClick: onClick, label: label })=>{
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        return;
    }, []);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        ref: ref,
        "aria-label": label,
        href: href,
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $k12R1.cx)($0587785bc5340d25$var$anchorStyles.root, $0587785bc5340d25$var$anchorStyles.customLogoBorderRadius, $0587785bc5340d25$var$anchorStyles.newMargin, hasCustomTheme ? $0587785bc5340d25$var$anchorStyles.newInteractionStatesCustomTheming : $0587785bc5340d25$var$anchorStyles.newInteractionStates),
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.root,
            $0587785bc5340d25$var$iconContainerStyles.root,
            isFhsEnabled && $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.withFullHeightSidebar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $oHJVG.LogoRenderer), {
        logoOrIcon: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.root,
            $0587785bc5340d25$var$logoContainerStyles.root,
            isFhsEnabled && $0587785bc5340d25$var$sharedIconOrLogoContainerStyles.withFullHeightSidebar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $oHJVG.LogoRenderer), {
        logoOrIcon: logo
    })));
};
module.exports["CustomLogo"] = $0587785bc5340d25$export$4156d88e9ccc616b;

});

parcelRegister("oHJVG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6cyWf = parcelRequire("6cyWf");

const $b21160af47e239eb$export$24328117f1132113 = '--ds-top-bar-logo-icon';
const $b21160af47e239eb$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
const $b21160af47e239eb$export$35e88bd9b061a3a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LogoRenderer(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { logoOrIcon: LogoOrIcon } = t0;
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    if (hasCustomTheme) {
        let t1;
        if ($[0] !== LogoOrIcon) {
            t1 = /*#__PURE__*/ $cozmU.createElement(LogoOrIcon, {
                label: "",
                size: "small",
                iconColor: `var(${$b21160af47e239eb$export$24328117f1132113})`,
                textColor: `var(${$b21160af47e239eb$export$91b0830f8f4ab279})`
            });
            $[0] = LogoOrIcon;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== LogoOrIcon) {
        t1 = /*#__PURE__*/ $cozmU.createElement(LogoOrIcon, {
            size: "small",
            label: "",
            appearance: "brand"
        });
        $[2] = LogoOrIcon;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function LogoRenderer({ logoOrIcon: LogoOrIcon }) {
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ $cozmU.createElement(LogoOrIcon, {
        label: "",
        size: "small",
        iconColor: `var(${$b21160af47e239eb$export$24328117f1132113})`,
        textColor: `var(${$b21160af47e239eb$export$91b0830f8f4ab279})`
    });
    return /*#__PURE__*/ $cozmU.createElement(LogoOrIcon, {
        size: "small",
        label: "",
        appearance: "brand"
    });
};
module.exports["themedLogoIcon"] = $b21160af47e239eb$export$24328117f1132113;
module.exports["themedLogoText"] = $b21160af47e239eb$export$91b0830f8f4ab279;
module.exports["LogoRenderer"] = $b21160af47e239eb$export$35e88bd9b061a3a4;

});

parcelRegister("cES0U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");


var $1fHIr = parcelRequire("1fHIr");


var $6cyWf = parcelRequire("6cyWf");


var $oHJVG = parcelRequire("oHJVG");

const $d728a4d07578a4cf$var$anchorStyles = {
    root: "_0bjKvD8fU6 _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VUofl _3YEZNOdnbC _0GTcwR1Y8M _4kLJBn98eZ _0mJftuYbGa _1vb6Qj6wH8 _4vhRtvOLYo",
    interactionStates: "_1eOmH6o126 _3gzVzLJovG",
    interactionStatesCustomTheming: "_1eOmH6JxD8 _3gzVzL8abp",
    fullHeightSidebar: "_4bt5LAnQyn _2WAcuGnQyn _3YEZNO7dHp"
};
const $d728a4d07578a4cf$var$logoWrapperStyles = {
    root: "_2Y7lL41Y8M",
    fullHeightSidebar: "_1EqgXlN91d"
};
const $d728a4d07578a4cf$var$iconContainerStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _1EqgXloWWg _0NUa3roWWg",
    fullHeightSidebar: "_3YEZNOdnbC"
};
const $d728a4d07578a4cf$var$logoTextStyles = {
    root: "_39xV02W9qI _1EqgXlsz7G _20VacPYbGa _03SyCPFQfX _3iDTPbYbGa _0aFT5vbt8w _37wbyuDIqT _2rc81eQ4SZ"
};
const $d728a4d07578a4cf$var$secondaryNameStyles = {
    root: "_43nrzTLl21"
};
function $d728a4d07578a4cf$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $d728a4d07578a4cf$export$113a612889e1565d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { name: name, label: label, secondaryName: secondaryName, href: href, icon: icon, onClick: onClick } = t0;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const ref = (0, $cozmU.useRef)(null);
    const nameRef = (0, $cozmU.useRef)(null);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    let t1;
    if ($[0] !== secondaryName) {
        t1 = Boolean(secondaryName) && (0, $iDrrr.fg)("platform_dst_ads_appswitcher_improvements");
        $[0] = secondaryName;
        $[1] = t1;
    } else t1 = $[1];
    const showSecondaryName = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const text = nameRef.current;
            return Boolean(text && $d728a4d07578a4cf$var$isTextClamped(text));
        };
        $[2] = t2;
    } else t2 = $[2];
    const canTooltipAppear = t2;
    const t3 = hasCustomTheme ? $d728a4d07578a4cf$var$anchorStyles.interactionStatesCustomTheming : $d728a4d07578a4cf$var$anchorStyles.interactionStates;
    const t4 = isFhsEnabled && $d728a4d07578a4cf$var$anchorStyles.fullHeightSidebar;
    let t5;
    if ($[3] !== t3 || $[4] !== t4) {
        t5 = (0, $k12R1.cx)($d728a4d07578a4cf$var$anchorStyles.root, t3, t4);
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const t6 = isFhsEnabled && $d728a4d07578a4cf$var$logoWrapperStyles.fullHeightSidebar;
    let t7;
    if ($[6] !== t6) {
        t7 = (0, $k12R1.cx)($d728a4d07578a4cf$var$logoWrapperStyles.root, t6);
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    const t8 = isFhsEnabled && $d728a4d07578a4cf$var$iconContainerStyles.fullHeightSidebar;
    let t9;
    if ($[8] !== t8) {
        t9 = (0, $hekY6.default)([
            $d728a4d07578a4cf$var$iconContainerStyles.root,
            t8
        ]);
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== icon) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $oHJVG.LogoRenderer), {
            logoOrIcon: icon
        });
        $[10] = icon;
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== t10 || $[13] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t9
        }, t10);
        $[12] = t10;
        $[13] = t9;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $hekY6.default)([
            $d728a4d07578a4cf$var$logoTextStyles.root
        ]);
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== name) {
        t13 = (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                "aria-hidden": true,
                color: "inherit",
                weight: "semibold",
                maxLines: 1,
                ref: nameRef
            }, name));
        $[16] = name;
        $[17] = t13;
    } else t13 = $[17];
    let t14;
    if ($[18] !== name || $[19] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: name,
            position: "bottom",
            ignoreTooltipPointerEvents: true,
            hideTooltipOnMouseDown: true,
            isScreenReaderAnnouncementDisabled: true,
            canAppear: canTooltipAppear
        }, t13);
        $[18] = name;
        $[19] = t13;
        $[20] = t14;
    } else t14 = $[20];
    let t15;
    if ($[21] !== secondaryName || $[22] !== showSecondaryName) {
        t15 = showSecondaryName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $d728a4d07578a4cf$var$secondaryNameStyles.root
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            "aria-hidden": true,
            color: "color.text.subtlest",
            weight: "regular",
            maxLines: 1,
            size: "small"
        }, secondaryName));
        $[21] = secondaryName;
        $[22] = showSecondaryName;
        $[23] = t15;
    } else t15 = $[23];
    let t16;
    if ($[24] !== t14 || $[25] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t12
        }, t14, t15);
        $[24] = t14;
        $[25] = t15;
        $[26] = t16;
    } else t16 = $[26];
    let t17;
    if ($[27] !== t11 || $[28] !== t16 || $[29] !== t7) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "center",
            xcss: t7
        }, t11, t16);
        $[27] = t11;
        $[28] = t16;
        $[29] = t7;
        $[30] = t17;
    } else t17 = $[30];
    let t18;
    if ($[31] !== href || $[32] !== label || $[33] !== onClick || $[34] !== t17 || $[35] !== t5) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            ref: ref,
            "aria-label": label,
            href: href,
            xcss: t5,
            onClick: onClick
        }, t17);
        $[31] = href;
        $[32] = label;
        $[33] = onClick;
        $[34] = t17;
        $[35] = t5;
        $[36] = t18;
    } else t18 = $[36];
    return t18;
} : ({ name: name, label: label, secondaryName: secondaryName, href: href, icon: icon, onClick: onClick })=>{
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const ref = (0, $cozmU.useRef)(null);
    const nameRef = (0, $cozmU.useRef)(null);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const showSecondaryName = Boolean(secondaryName) && (0, $iDrrr.fg)('platform_dst_ads_appswitcher_improvements'); /**
                                                                                                        * Show the tooltip if the name is truncated
                                                                                                        */ 
    const canTooltipAppear = (0, $cozmU.useCallback)(()=>{
        const text = nameRef.current;
        return Boolean(text && $d728a4d07578a4cf$var$isTextClamped(text));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        ref: ref,
        "aria-label": label,
        href: href,
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $k12R1.cx)($d728a4d07578a4cf$var$anchorStyles.root, hasCustomTheme ? $d728a4d07578a4cf$var$anchorStyles.interactionStatesCustomTheming : $d728a4d07578a4cf$var$anchorStyles.interactionStates, isFhsEnabled && $d728a4d07578a4cf$var$anchorStyles.fullHeightSidebar),
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "center",
        xcss: (0, $k12R1.cx)($d728a4d07578a4cf$var$logoWrapperStyles.root, isFhsEnabled && $d728a4d07578a4cf$var$logoWrapperStyles.fullHeightSidebar)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $d728a4d07578a4cf$var$iconContainerStyles.root,
            isFhsEnabled && $d728a4d07578a4cf$var$iconContainerStyles.fullHeightSidebar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $oHJVG.LogoRenderer), {
        logoOrIcon: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $d728a4d07578a4cf$var$logoTextStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: name,
        position: "bottom",
        ignoreTooltipPointerEvents: true,
        hideTooltipOnMouseDown: true // We don't need a duplicate hidden element containing tooltip content
        ,
        // as the content of the tooltip matches what is rendered in the nav item.
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canTooltipAppear
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            "aria-hidden": true,
            color: "inherit",
            weight: "semibold",
            maxLines: 1,
            ref: nameRef
        }, name))), showSecondaryName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $d728a4d07578a4cf$var$secondaryNameStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        "aria-hidden": true,
        color: "color.text.subtlest",
        weight: "regular",
        maxLines: 1,
        size: "small"
    }, secondaryName)))));
};
module.exports["AppLogo"] = $d728a4d07578a4cf$export$113a612889e1565d;

});

parcelRegister("lYmLF", function(module, exports) {
/* list-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");

function $611f591f5abbf0ae$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId
    }, children);
}
const $611f591f5abbf0ae$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $cozmU.forwardRef)($611f591f5abbf0ae$var$_ListItem);
module.exports["ListItem"] = $611f591f5abbf0ae$export$a7b06bfba60a8a78;

});

parcelRegister("c8bwf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lYmLF = parcelRequire("lYmLF");


var $bZTfQ = parcelRequire("bZTfQ");

const $18daf328df969fca$export$b3477e90773be2d0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(18);
    const { label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, isListItem: t1, shortcut: shortcut } = t0;
    const isListItem = t1 === undefined ? true : t1;
    const Wrapper = isListItem ? (0, $lYmLF.ListItem) : (0, $cozmU.Fragment);
    let t2;
    if ($[0] !== shortcut) {
        t2 = shortcut ? {
            shortcut: shortcut
        } : undefined;
        $[0] = shortcut;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== ariaControls || $[3] !== ariaExpanded || $[4] !== ariaHasPopup || $[5] !== forwardedRef || $[6] !== icon || $[7] !== interactionName || $[8] !== isSelected || $[9] !== label || $[10] !== onClick || $[11] !== onMouseEnter || $[12] !== t2 || $[13] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZTfQ.IconButton), {
            ref: forwardedRef,
            icon: icon,
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            appearance: "subtle",
            isSelected: isSelected,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            tooltip: t2
        });
        $[2] = ariaControls;
        $[3] = ariaExpanded;
        $[4] = ariaHasPopup;
        $[5] = forwardedRef;
        $[6] = icon;
        $[7] = interactionName;
        $[8] = isSelected;
        $[9] = label;
        $[10] = onClick;
        $[11] = onMouseEnter;
        $[12] = t2;
        $[13] = testId;
        $[14] = t3;
    } else t3 = $[14];
    let t4;
    if ($[15] !== Wrapper || $[16] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, null, t3);
        $[15] = Wrapper;
        $[16] = t3;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
} : ({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem = true, shortcut: shortcut }, forwardedRef)=>{
    const Wrapper = isListItem ? (0, $lYmLF.ListItem) : (0, $cozmU.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZTfQ.IconButton), {
        ref: forwardedRef,
        icon: icon,
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        appearance: "subtle",
        isSelected: isSelected,
        isTooltipDisabled: false,
        testId: testId,
        interactionName: interactionName,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        // Only creating object when shortcut is provided
        tooltip: shortcut ? {
            shortcut: shortcut
        } : undefined
    }));
});
module.exports["EndItem"] = $18daf328df969fca$export$b3477e90773be2d0;

});

parcelRegister("frwle", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dDJT6 = parcelRequire("dDJT6");


var $aZw4M = parcelRequire("aZw4M");


var $c8bwf = parcelRequire("c8bwf");

const $d9683d840faeac30$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $d9683d840faeac30$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Notifications(t0, ref) {
    const $ = (0, $bDgLe.c)(16);
    const { label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, isListItem: isListItem, badge: badge, shortcut: shortcut } = t0;
    let t1;
    if ($[0] !== ariaControls || $[1] !== ariaExpanded || $[2] !== ariaHasPopup || $[3] !== interactionName || $[4] !== isSelected || $[5] !== label || $[6] !== onClick || $[7] !== onMouseEnter || $[8] !== ref || $[9] !== shortcut || $[10] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            isSelected: isSelected,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            ref: ref,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dDJT6))),
            isListItem: false,
            shortcut: shortcut
        });
        $[0] = ariaControls;
        $[1] = ariaExpanded;
        $[2] = ariaHasPopup;
        $[3] = interactionName;
        $[4] = isSelected;
        $[5] = label;
        $[6] = onClick;
        $[7] = onMouseEnter;
        $[8] = ref;
        $[9] = shortcut;
        $[10] = testId;
        $[11] = t1;
    } else t1 = $[11];
    let t2;
    if ($[12] !== badge || $[13] !== isListItem || $[14] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZw4M.BadgeContainer), {
            id: $d9683d840faeac30$var$NOTIFICATIONS_BADGE_ID,
            badge: badge,
            isListItem: isListItem
        }, t1);
        $[12] = badge;
        $[13] = isListItem;
        $[14] = t1;
        $[15] = t2;
    } else t2 = $[15];
    return t2;
} : function Notifications({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem, badge: badge, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZw4M.BadgeContainer), {
        id: $d9683d840faeac30$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dDJT6))),
        // We explicitly set the EndItem to not be a list item,
        // because the BadgeContainer already has a list item role (if `isListItem` is true)
        isListItem: false,
        shortcut: shortcut
    }));
});
module.exports["Notifications"] = $d9683d840faeac30$export$36ba2f559d49a8f6;

});

parcelRegister("aZw4M", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $d45695ff1eab8d56$var$styles = {
    root: "_1mT5xdRAKS _3iDTPbQ4SZ",
    badgeContainer: "_1mT5xdWVPG _1ANEUSLRg7 _2I62gz5UaJ _3iC0zd8HPE _1pp6NdYbGa"
};
const $d45695ff1eab8d56$export$f710265eb5a003da = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children, id: badgeId, badge: Badge, isListItem: t1 } = t0;
    const isListItem = t1 === undefined ? true : t1;
    const t2 = isListItem ? "listitem" : undefined;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $d45695ff1eab8d56$var$styles.root
        ]);
        $[0] = t3;
    } else t3 = $[0];
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $d45695ff1eab8d56$var$styles.badgeContainer
        ]);
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] !== Badge) {
        t5 = /*#__PURE__*/ $cozmU.createElement(Badge, null);
        $[2] = Badge;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== badgeId || $[5] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: badgeId,
            "aria-hidden": true,
            className: t4
        }, t5);
        $[4] = badgeId;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== children || $[8] !== t2 || $[9] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: t2,
            className: t3
        }, children, t6);
        $[7] = children;
        $[8] = t2;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    return t7;
} : ({ children: children, id: badgeId, badge: Badge, isListItem: isListItem = true })=>/*#__PURE__*/ $cozmU.createElement("div", {
        role: isListItem ? 'listitem' : undefined,
        className: (0, $hekY6.default)([
            $d45695ff1eab8d56$var$styles.root
        ])
    }, children, /*#__PURE__*/ $cozmU.createElement("div", {
        id: badgeId,
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            $d45695ff1eab8d56$var$styles.badgeContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement(Badge, null)));
module.exports["BadgeContainer"] = $d45695ff1eab8d56$export$f710265eb5a003da;

});

parcelRegister("jov8i", function(module, exports) {
/**
 * @jsxRuntime classic
 */ 
var $cozmU = parcelRequire("cozmU");


var $kyJuy = parcelRequire("kyJuy");


var $aZw4M = parcelRequire("aZw4M");


var $c8bwf = parcelRequire("c8bwf");

const $e746a36e3c15cc87$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $e746a36e3c15cc87$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $cozmU.forwardRef)(function Help({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, isListItem: isListItem, badge: badge, shortcut: shortcut }, ref) {
    const sharedProps = {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))),
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        ref: ref,
        shortcut: shortcut
    };
    if (!badge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
        ...sharedProps,
        isListItem: isListItem
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZw4M.BadgeContainer), {
        id: $e746a36e3c15cc87$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
        ...sharedProps,
        // We explicitly set the EndItem to not be a list item,
        // because the BadgeContainer already has a list item role (if `isListItem` is true)
        isListItem: false
    }));
});
module.exports["Help"] = $e746a36e3c15cc87$export$1be7516c0280bee8;

});

parcelRegister("2kkx9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $c8bwf = parcelRequire("c8bwf");

const $854a0916fe50a452$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    let props;
    let src;
    if ($[0] !== t0) {
        ({ src: src, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = src;
    } else {
        props = $[1];
        src = $[2];
    }
    let t1;
    if ($[3] !== src) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                appearance: "circle",
                src: src,
                size: "small"
            });
        $[3] = src;
        $[4] = t1;
    } else t1 = $[4];
    const ProfileAvatar = t1;
    let t2;
    if ($[5] !== ProfileAvatar || $[6] !== props || $[7] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
            ...props,
            ref: ref,
            icon: ProfileAvatar
        });
        $[5] = ProfileAvatar;
        $[6] = props;
        $[7] = ref;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ src: src, ...props }, ref)=>{
    const ProfileAvatar = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "circle",
            src: src,
            size: "small"
        }), [
        src
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
        ...props,
        ref: ref,
        icon: ProfileAvatar
    });
});
module.exports["Profile"] = $854a0916fe50a452$export$5120f2d0b8d4cab8;

});

parcelRegister("fmilS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $11OF7 = parcelRequire("11OF7");


var $c8bwf = parcelRequire("c8bwf");

const $1167db19a1159546$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
            ...props,
            ref: ref,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($11OF7)))
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
        ...props,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($11OF7)))
    }));
module.exports["Settings"] = $1167db19a1159546$export$c72f6eaae7b9adff;

});

parcelRegister("aDfUy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hPGQU = parcelRequire("hPGQU");


var $lYmLF = parcelRequire("lYmLF");


var $ced2k = parcelRequire("ced2k");

const $3719731e1b51205c$export$88195aaac9f90319 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, interactionName: interactionName, href: href, label: label } = t0;
    let t1;
    if ($[0] !== href || $[1] !== interactionName || $[2] !== label || $[3] !== onClick || $[4] !== onMouseEnter || $[5] !== ref || $[6] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lYmLF.ListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ced2k.LinkIconButton), {
            ref: ref,
            label: label,
            href: href,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            testId: testId,
            interactionName: interactionName,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hPGQU))),
            appearance: "subtle",
            isTooltipDisabled: false
        }));
        $[0] = href;
        $[1] = interactionName;
        $[2] = label;
        $[3] = onClick;
        $[4] = onMouseEnter;
        $[5] = ref;
        $[6] = testId;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : ({ onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, interactionName: interactionName, href: href, label: label }, ref)=>/**
 * This component doesn't use `EndItem` internally because it renders a
 * `LinkIconButton` instead of an `IconButton`.
 *
 * We could make another abstraction, but this is the only top navigation item
 * that renders a link.
 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lYmLF.ListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ced2k.LinkIconButton), {
        ref: ref,
        label: label,
        href: href,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        testId: testId,
        interactionName: interactionName,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hPGQU))),
        appearance: "subtle",
        isTooltipDisabled: false
    })));
module.exports["LogIn"] = $3719731e1b51205c$export$88195aaac9f90319;

});

parcelRegister("ced2k", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7WEaj = parcelRequire("7WEaj");


var $6cyWf = parcelRequire("6cyWf");


var $2gbg3 = parcelRequire("2gbg3");

const $272bab02dc3bee02$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $2gbg3.ThemedLinkIconButton) : (0, $7WEaj.default);
    let t0;
    if ($[0] !== Component || $[1] !== props || $[2] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ref: ref,
            ...props
        });
        $[0] = Component;
        $[1] = props;
        $[2] = ref;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props, ref)=>{
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $2gbg3.ThemedLinkIconButton) : (0, $7WEaj.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        ref: ref,
        ...props
    });
});
module.exports["LinkIconButton"] = $272bab02dc3bee02$export$edad7fca51b767e1;

});

parcelRegister("2gbg3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4Qc44 = parcelRequire("4Qc44");


var $lmzCg = parcelRequire("lmzCg");


var $lpNn5 = parcelRequire("lpNn5");


var $9GVkD = parcelRequire("9GVkD");


var $iH8yB = parcelRequire("iH8yB");

const $af31664dceaf23c2$var$ThemedLinkIconButtonFn = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ThemedLinkIconButtonFn(t0, ref) {
    const $ = (0, $bDgLe.c)(14);
    let Icon;
    let label;
    let props;
    let tooltip;
    if ($[0] !== t0) {
        ({ icon: Icon, label: label, tooltip: tooltip, ...props } = t0);
        $[0] = t0;
        $[1] = Icon;
        $[2] = label;
        $[3] = props;
        $[4] = tooltip;
    } else {
        Icon = $[1];
        label = $[2];
        props = $[3];
        tooltip = $[4];
    }
    const t1 = tooltip?.content ?? label;
    let t2;
    if ($[5] !== Icon || $[6] !== label || $[7] !== props || $[8] !== ref) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iH8yB.ThemedAnchor), {
                ...props,
                shape: "square",
                ref: (0, $lmzCg.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e_0)=>{
                    triggerProps.onMouseOut?.(e_0);
                    props.onMouseOut?.(e_0);
                },
                onMouseMove: (e_1)=>{
                    triggerProps.onMouseMove?.(e_1);
                    props.onMouseMove?.(e_1);
                },
                onMouseDown: (e_2)=>{
                    triggerProps.onMouseDown?.(e_2);
                    props.onMouseDown?.(e_2);
                },
                onFocus: (e_3)=>{
                    triggerProps.onFocus?.(e_3);
                    props.onFocus?.(e_3);
                },
                onBlur: (e_4)=>{
                    triggerProps.onBlur?.(e_4);
                    props.onBlur?.(e_4);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                label: "",
                color: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, label));
        $[5] = Icon;
        $[6] = label;
        $[7] = props;
        $[8] = ref;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== t1 || $[11] !== t2 || $[12] !== tooltip) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            ...tooltip,
            content: t1
        }, t2);
        $[10] = t1;
        $[11] = t2;
        $[12] = tooltip;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : function ThemedLinkIconButtonFn({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        ...tooltip,
        content: tooltip?.content ?? label
    }, (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iH8yB.ThemedAnchor), {
            ...props,
            shape: "square",
            ref: (0, $lmzCg.default)([
                ref,
                triggerProps.ref
            ]),
            onClick: (event, analyticsEvent)=>{
                props.onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                props.onMouseOver?.(e);
            },
            onMouseOut: (e_0)=>{
                triggerProps.onMouseOut?.(e_0);
                props.onMouseOut?.(e_0);
            },
            onMouseMove: (e_1)=>{
                triggerProps.onMouseMove?.(e_1);
                props.onMouseMove?.(e_1);
            },
            onMouseDown: (e_2)=>{
                triggerProps.onMouseDown?.(e_2);
                props.onMouseDown?.(e_2);
            },
            onFocus: (e_3)=>{
                triggerProps.onFocus?.(e_3);
                props.onFocus?.(e_3);
            },
            onBlur: (e_4)=>{
                triggerProps.onBlur?.(e_4);
                props.onBlur?.(e_4);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, label)));
};
const $af31664dceaf23c2$export$a1ab08e79d264ec8 = (0, $4Qc44.default)($af31664dceaf23c2$var$ThemedLinkIconButtonFn);
module.exports["ThemedLinkIconButton"] = $af31664dceaf23c2$export$a1ab08e79d264ec8;

});

parcelRegister("iH8yB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $4Qc44 = parcelRequire("4Qc44");


var $7vK9E = parcelRequire("7vK9E");


var $hVZgb = parcelRequire("hVZgb");

const $b22d7f94684fcdb0$var$styles = {
    root: "_2mHwu8gVvo _2sNsIgmnOE _0bjKvDKTcp _23rrnHyKLB _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VymQ6 _1mT5xdRAKS _3WzCGi98eZ _32C2rk98eZ _0DCa9D98eZ _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8 _3sFUREiSCN",
    border: "_2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _0GBAIrogpp _2WYcYGWVPG",
    selected: "_2uo31fhe06 _1UtDYzysOt _0z8nYC0GCl _10n1R5ysOt _2nTuUYysOt _30zrXRUQDy _0clgaMysOt _1gxogc4k8R _0CMRbkysOt",
    disabled: "_2uo31ftHCb _1UtDYzn3Ip _0z8nYCjOvk _10n1R5n3Ip _2nTuUYn3Ip _30zrXRtHCb _0clgaMn3Ip _1gxogctHCb _0CMRbkn3Ip"
};
const $b22d7f94684fcdb0$var$appearanceStyles = {
    default: "_2uo31fGfro _1UtDYz98eZ _0z8nYCQMmr _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    subtle: "_2uo31fGfro _1UtDYz98eZ _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    primary: "_2uo31fxjIo _1UtDYzwGpT _10n1R5wGpT _2nTuUYwGpT _30zrXR2rJx _0clgaMwGpT _1gxogcHVA2 _0CMRbkwGpT"
};
const $b22d7f94684fcdb0$var$shapeStyles = {
    default: "_2Y7lL48HPE",
    square: "_2Y7lL4Pgdg _39xV02ymQ6 _26BoRwdnbC"
}; /**
    * Props that are common between link buttons.
    */ 
const $b22d7f94684fcdb0$var$ThemedAnchorFn = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ThemedAnchorFn(t0, ref) {
    const $ = (0, $bDgLe.c)(19);
    let T0;
    let appearance;
    let hasBorder;
    let isDisabled;
    let isSelected;
    let shape;
    let t1;
    if ($[0] !== t0) {
        const { appearance: t2, shape: t3, isSelected: t4, isDisabled: t5, ...props } = t0;
        isSelected = t4;
        isDisabled = t5;
        appearance = t2 === undefined ? "default" : t2;
        shape = t3 === undefined ? "default" : t3;
        hasBorder = appearance === "default" || isSelected;
        T0 = (0, $7vK9E.Anchor);
        t1 = (0, $hVZgb.getPrimitiveSpreadProps)(props);
        $[0] = t0;
        $[1] = T0;
        $[2] = appearance;
        $[3] = hasBorder;
        $[4] = isDisabled;
        $[5] = isSelected;
        $[6] = shape;
        $[7] = t1;
    } else {
        T0 = $[1];
        appearance = $[2];
        hasBorder = $[3];
        isDisabled = $[4];
        isSelected = $[5];
        shape = $[6];
        t1 = $[7];
    }
    const t2 = $b22d7f94684fcdb0$var$shapeStyles[shape];
    const t3 = hasBorder && $b22d7f94684fcdb0$var$styles.border;
    const t4 = $b22d7f94684fcdb0$var$appearanceStyles[appearance];
    const t5 = isSelected && $b22d7f94684fcdb0$var$styles.selected;
    const t6 = isDisabled && $b22d7f94684fcdb0$var$styles.disabled;
    let t7;
    if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
        t7 = (0, $k12R1.cx)($b22d7f94684fcdb0$var$styles.root, t2, t3, t4, t5, t6);
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== T0 || $[15] !== ref || $[16] !== t1 || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            ref: ref,
            xcss: t7
        });
        $[14] = T0;
        $[15] = ref;
        $[16] = t1;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
} : function ThemedAnchorFn({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        ...(0, $hVZgb.getPrimitiveSpreadProps)(props),
        ref: ref,
        // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $k12R1.cx)($b22d7f94684fcdb0$var$styles.root, $b22d7f94684fcdb0$var$shapeStyles[shape], hasBorder && $b22d7f94684fcdb0$var$styles.border, $b22d7f94684fcdb0$var$appearanceStyles[appearance], isSelected && $b22d7f94684fcdb0$var$styles.selected, isDisabled && $b22d7f94684fcdb0$var$styles.disabled)
    });
};
const $b22d7f94684fcdb0$export$1b69d1a78614cc52 = (0, $4Qc44.default)($b22d7f94684fcdb0$var$ThemedAnchorFn);
module.exports["ThemedAnchor"] = $b22d7f94684fcdb0$export$1b69d1a78614cc52;

});

parcelRegister("ldb5c", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6cyWf = parcelRequire("6cyWf");

const $74d051d9a1974270$var$styles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _1ANEUSLRg7 _1EqgXlgZxp _39HuIbz8Lp _0LQT5E1Y8M _03SyCP2ADO _3iDTPbYbGa _2rc81eQ4SZ",
    subtleText: "_1UtDYzZpcK"
};
const $74d051d9a1974270$export$9ccddf7ee2a0e24e = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function CustomTitle(t0, ref) {
    const $ = (0, $bDgLe.c)(7);
    const { children: children, testId: testId } = t0;
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const t1 = !hasCustomTheme && $74d051d9a1974270$var$styles.subtleText;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $hekY6.default)([
            $74d051d9a1974270$var$styles.root,
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== ref || $[4] !== t2 || $[5] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            ref: ref,
            "data-testid": testId,
            className: t2
        }, children);
        $[2] = children;
        $[3] = ref;
        $[4] = t2;
        $[5] = testId;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : function CustomTitle({ children: children, testId: testId }, ref) {
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $74d051d9a1974270$var$styles.root,
            !hasCustomTheme && $74d051d9a1974270$var$styles.subtleText
        ])
    }, children);
});
module.exports["CustomTitle"] = $74d051d9a1974270$export$9ccddf7ee2a0e24e;

});


//# sourceMappingURL=top-nav-items.5e217bf2.js.map
